/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createReplacer } from '../../factoriesAny.js';
export var replacerDependencies = {
  createReplacer: createReplacer
};